import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {
  TUIChatService,
  TUIStore,
  StoreName,
  IConversationModel,
  TUITranslateService,
} from '../../../../@aidesk/uikit-engine';
import vue from '../../../../adapter-vue';
import { isPC, isH5 } from '../../../../utils/env';
import ToolbarItemContainer from '../toolbar-item-container/index.vue';
import ratingToolIcon from '../../../../assets/rating_tool_icon.svg'
import ratingToolIconH5 from '../../../../assets/rating_tool_icon_h5.svg';
import { getTo } from '../../../../utils/utils';
import { CUSTOM_MESSAGE_SRC } from '../../../../constant';

export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  isH5ToolShow:{
    type: Boolean,
    default: false,
  },
  title: {
    type: String,
    default: TUITranslateService.t('AIDesk.提交评价')
  },
  icon: {
    type: String,
    default: '',
  }
},
  setup(__props) {

const { ref } = vue;

const props = __props;

const currentConversation = ref<IConversationModel>();

TUIStore.watch(StoreName.CONV, {
  currentConversation: (conversation: IConversationModel) => {
    currentConversation.value = conversation;
  },
});

const getIcon = (): string => {
  return isH5 ? ratingToolIconH5 : ratingToolIcon;
}

const onIconClick = () => {
  TUIChatService.sendCustomMessage({
    to: getTo(currentConversation?.value),
    conversationType: currentConversation?.value?.type,
    payload:{
      data:JSON.stringify({
        src: CUSTOM_MESSAGE_SRC.USER_SATISFACTION,
        customerServicePlugin: 0,
      }),
    },
  },{ onlineUserOnly: true })
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ToolbarItemContainer, {
    iconFile: getIcon(),
    title: props.title,
    iconWidth: _unref(isPC) ? '20px' : '25px',
    iconHeight: _unref(isPC) ? '20px' : '25px',
    needDialog: false,
    onOnIconClick: onIconClick,
    isH5ToolShow: __props.isH5ToolShow
  }, null, 8, ["iconFile", "title", "iconWidth", "iconHeight", "isH5ToolShow"]))
}
}

})